import styled from 'styled-components';
import {
  size,
  SizeProps,
  width,
  WidthProps,
  minWidth,
  MinWidthProps,
  height,
  HeightProps,
  borders,
  BordersProps
} from 'styled-system';

import { objectFit } from 'src/helpers';
import { Text, TextProps } from './Text';

export type CircleProps = TextProps &
  SizeProps &
  WidthProps &
  MinWidthProps &
  HeightProps &
  BordersProps & { objectFit?: string };

export const Circle = styled(Text).attrs((p: CircleProps) => ({ minWidth: p.minWidth || p.size }))<CircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${size};
  ${width};
  ${minWidth};
  ${height};
  ${borders};
  ${objectFit};
`;
